// FILE: src/components/shell/ThemeToggle.jsx
// Light/dark switch in the top bar (plan WP-8 task 5, matrix 10.3). The
// default follows the device (mode "system"); a click picks the opposite of
// what is showing and MUI remembers it in localStorage ("mui-mode").
import { IconButton, Tooltip } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";

export function useResolvedScheme() {
  const { mode, systemMode, setMode } = useColorScheme();
  const resolved = (mode === "system" ? systemMode : mode) || "light";
  return { mode: mode || "system", resolved, setMode };
}

export default function ThemeToggle() {
  const { resolved, setMode } = useResolvedScheme();
  const next = resolved === "dark" ? "light" : "dark";
  const label = next === "dark" ? "Switch to dark theme" : "Switch to light theme";
  return (
    <Tooltip title={label}>
      <IconButton onClick={() => setMode(next)} aria-label={label} data-testid="theme-toggle" color="inherit">
        {resolved === "dark" ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
